import DataTable from 'datatables.net-react';
import { useEffect, useState } from "react";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ClosingRateService } from "../../services/ClosingRateService";
import * as BullCache from "../../util/BullCache";
import MarketDropdown from "../components/MarketDropdown";
import ScriptDropdown from "../components/ScriptDropdown";

function ClosingRate() {

    var allScripts = BullCache.getFromCache('allScripts');
    var user = BullCache.getFromCache("user");

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false); 
    const [selectedMarket, setSelectedMarket] = useState('');
    const [selectedScript, setSelectedScript] = useState('');
    const [closingRateList, setClosingRateList] = useState([]);
    const [filteredClosingRateList, setFilteredClosingRateList] = useState([]);
    const [selectedItem, setSelectedItem] = useState([]);
    const [file, setFile] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [lastBillGenerate, setLastBillGenerate] = useState('');


    const fetchClosingRateList = () => {
      setLoading(true);

        ClosingRateService.getClosingrate({ 'adminId': user.adminId }).then(res => {
        setLoading(false);
            if (res.code === 1) {
                const allLists = Object.values(res.data.closingRateList).flat();
                setClosingRateList(allLists);
                setFilteredClosingRateList(allLists);
                setLastBillGenerate(res.data.lastBillGeneratedOn);
            }
        });
    };

    useEffect(() => {
        fetchClosingRateList();
    }, []);


    const handleMarketChange = (market) => {
        setSelectedMarket(market);
    };

    const handleScriptChange = (script) => {
        setSelectedScript(script);
    };

    const handleScriptReset = () => {
        setSelectedScript(null);
    };

    const handleClose = () => {
        setShowModal(false);
    };

    const handleAdd = () => {
        navigate('/addclosingrate');
    };

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleSaveChanges = () => {
        const selectedData = {
            adminId: user.adminId,
            closingRateId: selectedItem.closingRateId,
            rate: selectedItem.rate
        };

        const updatedList = closingRateList.map(item => {
            if (item.closingRateId === selectedData.closingRateId) {
                return { ...item, rate: selectedData.rate }; 
            }
            return item;
        });
        
        const updatedFilteredList = filteredClosingRateList.map(item => {
            if (item.closingRateId === selectedData.closingRateId) {
                return { ...item, rate: selectedData.rate }; 
            }
            return item;
        });
        
        // Update the state directly without fetching data again
        setClosingRateList(updatedList);
        setFilteredClosingRateList(updatedFilteredList);        

        ClosingRateService.UpdateClosingRate(selectedData)
            .then(res => {
                if (res.code === 1) {
                    Swal.fire({
                        icon: "success",
                        text: "Updated Successfully!!.."
                    });
                    setShowModal(false);
                }
            })
            .catch(error => {
                alert('Error updating data.');
            });
    };

    const handleBillGenerate = () => {
        Swal.fire({
            title: 'Are you sure?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes ',
            cancelButtonText: 'No',
            cancelButtonColor: "#d33",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                ClosingRateService.GenerateBill({ 'adminId': user.adminId }).then(res => {
                    setLoading(false);
                    if (res.code === 1) {
                        Swal.fire({
                            icon: 'success',
                            text: 'Bill Generated Successfully'
                        })
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: res.messages || "Found an issue while generating bill!"
                        });
                    }
                });
            }
          });
    }

    const handleSearch = () => {
        setLoading(true);
        let filteredData = closingRateList;

        if (selectedMarket) {
            filteredData = filteredData.filter(item => item.segment === selectedMarket);
        }

        if (selectedScript) {
            filteredData = filteredData.filter(item => item.script === selectedScript);
        }
        setTimeout(() => {
            setFilteredClosingRateList(filteredData);
            setLoading(false);  
        }, 1000); 
    };

    useEffect(() => {
        const handleEditClick = (event) => {

            const rowId = event.target.getAttribute("data-id");
            const rowData = filteredClosingRateList[rowId];
            setSelectedItem(rowData);
            setShowModal(true);
        };

        document.addEventListener("click", (event) => {
            if (event.target.classList.contains("icon-pencil")) {
                handleEditClick(event);
            }
        });

        return () => {
            document.removeEventListener("click", handleEditClick);
        };
    }, [filteredClosingRateList]);

    const handleUpload = () => {
        if (file) {
            const formData = new FormData();
            formData.append("closingRateFile", file);
            setLoading(true);
            ClosingRateService.UploadClosingRate(formData)
                .then(res => {
                    setLoading(false);
                    if (res.code === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "File Uploaded Successfully!!.."
                        });
                        setFile(null);
                        document.getElementById('fileInput').value = '';

                        fetchClosingRateList();
                    }
                })
                .catch(error => {
                    alert('Error: ' + error.message);
                });

        } else {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Please Select a File!",
            });
            return;
        }
    };

    const columns = [
        {
            title: "SEGMENT",
            data: "segment"
        },
        {
            title: "SYMBOL",
            data: "script",
        },
        {
            title: "EXPIRY DATE",
            data: "expiryDate",
        },
        {
            title: "CLOSING RATE",
            data: "rate",
        },
        {
            title: "LAST UPDATED",
            data: "auditTimestamp",
        },
        {
            title: "ACTION",
            render: (data, type, row, full, meta) => {
                return `
              <i class="me-3 fa fa-pencil icon-pencil" data-id="${full.row}" style="cursor: pointer"></i>
              <i class="icon-trash fa fa-trash" style="cursor: pointer; color: red"></i>
            `;
            },
        },
    ]

    return (
        <div>
            <Card className='mt-1'>
                <Card.Body>
                    
                    <Row>
                        <Col className=''  xs={12} sm={6} xl={4}>
                        <Row>
                            <Col  xs={8} >
                            <Form.Group controlId="formFile">
                                <Form.Label><b className="fss-05">UPLOAD FILE</b></Form.Label>
                                <Form.Control
                                    id="fileInput"
                                    className='bg-light text-black'
                                    type="file"
                                    onChange={handleFileChange}
                                    size="sm"
                                />
                            </Form.Group>
                            </Col>
                            <Col  xs={4} className="pt-2">
                            <Button variant="success" size="sm" className='mt-4' onClick={handleUpload} >
                                Upload
                            </Button>
                            </Col>
                        </Row>
                            

                           
                        </Col>

                        <Col className=' mt-2' xs={6} xl={2} sm={3}>
                            <b className='fss-05'>MARKET</b>
                            <MarketDropdown
                                allScripts={allScripts}
                                onMarketChange={handleMarketChange}
                                onScriptReset={handleScriptReset} />
                        </Col>

                        <Col className=' mt-2' xs={6} xl={2} sm={3}>
                            <b className='fss-05'>SCRIPT NAME</b>

                            <ScriptDropdown
                                allScripts={allScripts}
                                selectedMarket={selectedMarket}
                                onScriptChange={handleScriptChange}
                            />
                        </Col>

                        <Col className='mt-2 text-end' xs={12} xl={4}>
                        <label> {lastBillGenerate}</label> <br />
                        
                            <Button variant="success" size="sm " className=' me-3' onClick={handleSearch}>
                                Search
                            </Button>

                            <Button variant="success" size="sm " className=' me-3' onClick={handleAdd}>
                                Add ClosingRate
                            </Button>
                                <Button variant="secondary" size="sm" className="" onClick={handleBillGenerate}>
                                    Generate Bill
                                </Button>
                        </Col>
                    </Row>

                </Card.Body>
            </Card>

            <Card className="mt-2">
                <Card.Body>
                    <div className="table-responsive">
                        {loading ? (
                            <div className="container vh-100">
                                <div className="d-flex align-items-center justify-content-center h-90">
                                    <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <DataTable
                                id="table"
                                columns={columns}
                                data={filteredClosingRateList}
                                className="table table-bordered bg-head-secondary fss-06 white-bordered-table"

                            />
                        )}
                    </div>
                </Card.Body>
            </Card>


            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit ClosingRate</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedItem && (
                        <Form>
                            <Row>
                                <Col>
                                    <Form.Group controlId="formMarket">
                                        <Form.Label>Market</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={selectedItem.segment}
                                            readOnly
                                        />
                                    </Form.Group>
                                </Col>

                                <Col>
                                    <Form.Group controlId="formScript">
                                        <Form.Label>Symbol</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={selectedItem.script}
                                            readOnly
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group controlId="formScript">
                                        <Form.Label>Expiry Date</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={selectedItem.expiryDate}
                                            readOnly
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="formScript">
                                        <Form.Label>Closing Rate</Form.Label>
                                        <Form.Control
                                            type="number"
                                            value={selectedItem.rate}
                                            onChange={(e) => {
                                                setSelectedItem({ ...selectedItem, rate: e.target.value });
                                            }}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                        </Form>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="danger" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="success" onClick={handleSaveChanges}>
                        Update
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>
    );
}
export default ClosingRate;
